import {HttpClient} from '@angular/common/http';
import {UntypedFormGroup, UntypedFormControl, Validators, FormControl, ValidatorFn, AbstractControl, ValidationErrors} from '@angular/forms';
import {Component, OnInit} from '@angular/core';
import swal from 'sweetalert2';
import {Meta, Title} from '@angular/platform-browser';
import {LolDivisions} from '../../../../../shared/utils/lol-divisions';
import {ValorantDivisions} from '../../../../../shared/utils/valorant-divisions';
import {WildRiftDivisions} from '../../../../../shared/utils/wild-rift-divisions';
import {Divisions, DivisionsService} from "../../../../../shared/modules/core/services/divisions.service";
import { ActivatedRoute, Router } from '@angular/router';
import { TranslationService } from 'src/apps/shared/services/translations.service';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'app-booster-application',
  templateUrl: './booster-application.component.html',
  styleUrls: ['./booster-application.component.scss']
})
export class BoosterApplicationComponent implements OnInit {
  protected readonly Divisions = Divisions;
  protected readonly DivisionsService = DivisionsService;

  divisions = Divisions;

  form = new UntypedFormGroup({
    game: new UntypedFormControl('', Validators.required),
    discord: new UntypedFormControl('', Validators.required),
    opgg: new UntypedFormControl(),
    email: new UntypedFormControl('', Validators.required),
    rank: new UntypedFormControl('', Validators.required),
    // server: new UntypedFormControl('', Validators.required),
    regionAmericas: new UntypedFormControl(false, Validators.required),
    regionEurope: new UntypedFormControl(false, Validators.required),
    regionOceania: new UntypedFormControl(false, Validators.required),
    regionAsia: new UntypedFormControl(false, Validators.required),

    platformPc: new UntypedFormControl(false, Validators.required),
    platformPs: new UntypedFormControl(false, Validators.required),
    platformXbox: new UntypedFormControl(false, Validators.required),
    age: new FormControl(0),
    name: new UntypedFormControl('', Validators.required),
    averageNumberOfHours: new UntypedFormControl('4', [Validators.required, Validators.pattern('^[0-9]+$')]),
    country: new UntypedFormControl('', Validators.required),
    introduction: new UntypedFormControl('', Validators.required),
  }, { validators: [this.atLeastOneRegionSelected(), this.atLeastOnePlatformSelected()] });

  leagueRanks;
  valorantRanks;
  wildRiftRanks;

  page = {
    title: {
      en: "Job Opportunities - Booster application GGBOOST",
      fr: "Opportunités d'emploi - Candidature Booster GGBOOST",
      de: "Stellenangebote - Booster-Bewerbung GGBOOST",
      pt: "Oportunidades de Emprego - Candidatura para booster GGBOOST",
      es: "Oportunidades de empleo - Candidatura Booster GGBOOST"
    },
    metaDescription: {
      en: "We are continuously looking for top-tier Elo Boosting talent, so if you think you have what it takes for the job, don't wait to send in your application.",
      fr: "Nous sommes constamment à la recherche des meilleurs talents pour Elo Boosting, alors si vous pensez avoir ce qu'il faut pour le job, n'attendez pas pour envoyer votre candidature.",
      de: "Erstklassige Elo Boosting-Talente suchen wir ständig. Warte also nicht mit deiner Bewerbung, wenn du glaubst, dass du das Zeug dazu hast.",
      pt: "Estamos constantemente à procura de talentos de Elo Boosting de alto nível, por isso, se achas que tens o que é preciso para o trabalho, não hesites em enviar a tua candidatura.",
      es: "Buscamos continuamente talentos de primer nivel para Elo Boosting, así que si crees que tienes lo que se necesita para el puesto, no esperes a enviar tu candidatura."
    },
    translations: {
      en: {
        title: "Booster Application",
        warning: "Warning for boosters!",
        warning1: "GGBOOST will ONLY reach you for recruitment purposes on the below mentioned contacts. Ignore and report to us any other contact attempt.",
        warning2: "Please, make sure to fill the application form before adding any of the contacts above.",
        recruiter: "Recruiter",
        assistant: "Assistant",

        name: "Name (First and Last) *",
        age: "Age *",
        country: "Country *",
        game: "Game *",
        currentRank: "Current Rank *",
        boostRegion: "Region you can boost *",
        platform: "Platform *",
        avgHours: "Average number of hours played daily *",
        hours: "Hours",
        onlineProfile: "Online Profile Link (if available)",
        aboutYou: "Tell us about your booster experience and why you should work with us *",
        pleaseFill: "Please fill all fields marked with *",
        sendApplication: "Send Application"
      },
      fr: {
        title: "Candidature Booster",
        warning: "Avertissement pour les boosters!",
        warning1: "GGBOOST vous contactera UNIQUEMENT à des fins de recrutement via les contacts mentionnés ci-dessous. Ignorez et signalez-nous toute autre tentative de contact",
        warning2: "Veuillez remplir le formulaire de candidature avant d'ajouter l'un des contacts ci-dessous",
        recruiter: "Recruteur",
        assistant: "Assistant",

        name: "Prénom et Nom *",
        age: "Age *",
        country: "Pays *",
        game: "Jeu *",
        currentRank: "Rang Actuel *",
        boostRegion: "Région que vous pouvez booster *",
        platform: "Plateforme *",
        avgHours: "Nombre moyen d'heures de jeu par jour *",
        hours: "Heures",
        onlineProfile: "Lien du Profil en Ligne (si disponible)",
        aboutYou: "Racontez-nous votre expérience de booster et expliquez-nous pourquoi vous souhaitez travailler avec nous *",
        pleaseFill: "Veuillez remplir tous les champs marqués d'un *",
        sendApplication: "Envoyer la Candidature"
      },
      de: {
        title: "Booster-Bewerbung",
        warning: "Achtung, Booster!",
        warning1: "GGBOOST wird sich über die unten angegebenen Kontakte NUR mit dir in Verbindung setzen, um dich zu rekrutieren. Ignoriere alle anderen Kontaktversuche und melde sie uns.",
        warning2: "Bitte stelle sicher, dass du das Bewerbungsformular ausfüllst, bevor du einen der oben genannten Kontakte hinzufügst.",
        recruiter: "Personaler",
        assistant: "Assistent",

        name: "Name (Vor- und Nachname) *",
        age: "Alter *",
        country: "Land *",
        game: "Spiel *",
        currentRank: "Aktueller Rang *",
        boostRegion: "Region, wo du boosten kannst *",
        platform: "Plattform *",
        avgHours: "Durchschnittliche Anzahl der täglich gespielten Stunden *",
        hours: "Stunden",
        onlineProfile: "Link zum Online-Profil (falls verfügbar)",
        aboutYou: "Schildere uns dein Booster-Erlebnis und warum du mit uns zusammenarbeiten solltest*.",
        pleaseFill: "Bitte fülle alle Felder aus, mit einem *",
        sendApplication: "Bewerbung abschicken"
      },
      pt: {
        title: "Candidatura de booster",
        warning: "Aviso para boosters!",
        warning1: "GGBOOST irá contatar-te APENAS para fins de recrutamento nos contactos abaixo mencionados. Ignore e reporte-nos qualquer outra tentativa de contacto.",
        warning2: "Por favor, certifica-te que preenches o formulário de candidatura antes de adicionar qualquer um dos contactos acima.",
        recruiter: "Recrutador",
        assistant: "Assistente",

        name: "Nome (Primeiro e Último) *",
        age: "Idade *",
        country: "País *",
        game: "Jogo *",
        currentRank: "Rank atual *",
        boostRegion: "Região que podes boostar *",
        platform: "Plataforma *",
        avgHours: "Número médio de horas jogadas diariamente *",
        hours: "Horas",
        onlineProfile: "Link do Perfil Online (se disponível)",
        aboutYou: "Conta-nos sobre a tua experiência como booster e por que devias trabalhar connosco *",
        pleaseFill: "Por favor, preenche todos os campos marcados com *",
        sendApplication: "Enviar Candidatura"
      },
      es: {
        title: "Candidatura Booster",
        warning: "¡Advertencia para Boosters!",
        warning1: "GGBOOST SÓLO se pondrá en contacto contigo con fines de contratación a través de los contactos mencionados a continuación. Ignora e infórmanos de cualquier otro intento de contacto.",
        warning2: "Por favor, asegúrate de rellenar el formulario de solicitud antes de añadir cualquiera de los contactos anteriores.",
        recruiter: "Reclutador",
        assistant: "Asistente",

        name: "Nombre (nombre y apellidos) *",
        age: "Edad *",
        country: "País *",
        game: "Juego *",
        currentRank: "Rango actual *",
        boostRegion: "Región que puedes potenciar *",
        platform: "Plataforma *",
        avgHours: "Número medio de horas de juego diarias *",
        hours: "Horas",
        onlineProfile: "Enlace al perfil en línea (si está disponible)",
        aboutYou: "Cuéntanos tu experiencia booster y por qué deberías trabajar con nosotros *",
        pleaseFill: "Rellena todos los campos marcados con *",
        sendApplication: "Enviar candidatura"
      }
    }
  }

  lang: string = 'en';

  constructor(private http: HttpClient, title: Title, meta: Meta, private route: ActivatedRoute, private router: Router, private translationService: TranslationService, private cookie: CookieService) {
    title.setTitle(this.page.title[this.lang] || this.page.title['en']);
    meta.updateTag(
      {
        name: 'description',
        content: this.page.metaDescription[this.lang] || this.page.metaDescription['en']
      }
    );

    this.leagueRanks = [
      {
        label: 'Select a rank',
        value: ''
      },
      ...LolDivisions.filter((item, index) => index > 21 && index !== 26).map(div => {
        return {
          label: div,
          value: LolDivisions.indexOf(div)
        };
      })
    ];

    this.valorantRanks = [
      {label: 'Select a rank', value: ''},
      ...ValorantDivisions.filter((item, index) => index > 17 && index < 25).map(div => {
        return {
          label: div,
          value: ValorantDivisions.indexOf(div)
        };
      })
    ];

    this.wildRiftRanks = [
      {label: 'Select a rank', value: ''},
      ...WildRiftDivisions.filter((item, index) => index > 23 && index < 30).map(div => {
        return {
          label: div,
          value: WildRiftDivisions.indexOf(div)
        };
      })
    ];
  }

  minRank = {
    'lol': 'Diamond I',
    'tft': 'Diamond I',
    'wild-rift': 'Diamond I',
    'valorant': 'Immortal III',
    'apex': 'Master',
    'overwatch': 'Master 5',
    'codmw2': 'Crimson 1',
    'codwz2': 'Crimson 1',
    'cs2': '25000',
    'marvel': 'Grandmaster III',
  };

  // Custom validator to ensure at least one region is selected
  private atLeastOneRegionSelected(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const regions = ['regionAmericas', 'regionEurope', 'regionOceania', 'regionAsia'];
      const isAnyRegionSelected = regions.some(region => control.get(region)?.value === true);
      return isAnyRegionSelected ? null : { atLeastOneRegion: true };
    };
  }

  // Custom validator to ensure at least one platform is selected
  private atLeastOnePlatformSelected(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const platforms = ['platformPc', 'platformPs', 'platformXbox'];
      const isAnyPlatformSelected = platforms.some(platform => control.get(platform)?.value === true);
      return isAnyPlatformSelected ? null : { atLeastOnePlatform: true };
    };
  }

  // Method to get the ranks based on game
  getRanks(game: string) {
    const minRank = this.minRank[game];
    const minIndex = this.divisions[game].indexOf(minRank);
    return (minIndex !== -1) ? this.divisions[game].slice(minIndex) : this.divisions[game];
  }

  ngOnInit() {
    this.form.get('age').valueChanges.subscribe(val => {
      if (val < 0) {
        this.form.get('age').setValue(0, { emitEvent: false });
      } else if (val > 99) {
        this.form.get('age').setValue(99, { emitEvent: false });
      }
    });
  }

  onSubmit() {
    this.form.value.rank = parseInt(this.form.value.rank, 10);

    const server = [];
    if (this.form.value.regionAmericas) server.push('americas');
    if (this.form.value.regionEurope) server.push('europe');
    if (this.form.value.regionOceania) server.push('oceania');
    if (this.form.value.regionAsia) server.push('asia');

    const platforms = [];
    if (this.form.value.platformPc) platforms.push('pc');
    if (this.form.value.platformPs) platforms.push('ps');
    if (this.form.value.platformXbox) platforms.push('xbox');

    const data = {
      ...this.form.value,
      server: server,
      platforms: platforms
    }

    if (this.form.valid) {
      this.http.post('/booster-application', data).subscribe((resp: any) => {
        if (resp.success) {
          this.form.reset();
          swal.fire('Success', 'You have successfully posted your application! We will contact you soon!', 'success');
        } else {
          swal.fire('Error', resp.error, 'error');
        }
      });
    }
  }
}